<template>
    <v-row no-gutters>
        <v-dialog
            v-model="dialog"
            @click:outside="closeDialog"
            scrollable
            width="600px"
        >
            <v-card>
                <v-card-text class="pa-0">
                    <v-card-text class="pa-4">
                        <span class="text-h6">Have you checked for duplicates?</span><br/><br/>
                        <span class="text-body-1">Please check for duplicate companies and merge them before continuing with the scrape, to ensure no duplicate properties are being created.</span><br/><br/>
                        <span class="text-body-1"><strong>Remember:</strong> users can create new companies at any time, so it’s important to check this regularly!</span>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" outlined depressed @click="showRetailerDialog()">Continue</v-btn>
                        <v-btn color="" outlined depressed @click="closeDialog">Close</v-btn>
                    </v-card-actions>
                </v-card-text>
            </v-card>
        </v-dialog>
        <view-retailer-dialog ref="viewRetailerDialog"></view-retailer-dialog>
        <view-links ref="viewLinks"></view-links>
        <edit-company-dialog ref="editCompanyDialog" @updated="getData"></edit-company-dialog>
        <v-col>
            <v-toolbar dense :elevation="0" class="rpd-toolbar">
                <div class="text-primary-700" style="font-weight: 700; display: grid;">
                    <span style="font-size: large">Tracked Retailers</span>
                    <span style="margin-top:-10px">
                    <a href="https://rp-database.com/docs/concepts/schemes-properties#properties-list" target="_blank" rel="noopener noreferrer" class="title-docs" style="font-size: small;">Open Docs</a>
                    </span>
                </div>
                <v-spacer></v-spacer>
                <!-- <v-btn @click="showRetailerDialog" class="mr-4" color="primary" height="40" outlined dark>Show Dialog</v-btn> -->
                 <v-checkbox v-model="showVerified" label="Hide Verified" hide-details @change="getData" class="mr-4"></v-checkbox>
                 <v-menu
                    :close-on-content-click="false"
                    offset-y
                    min-width="auto"
                    >
                    <template #activator="{ on }">
                    <v-btn
                        v-on="on"
                        class="mr-4"
                        :color="categoryFilter.length > 0 ? 'primary' : 'grey darken-3'"
                        small
                        outlined
                        :loading="loading"
                        height="40"
                    >
                        Categories <v-icon right>mdi-filter</v-icon> 
                    </v-btn>
                    </template>
                    <v-list style="width: 300px; max-height: 400px; overflow-y: auto;">
                    <v-list-item-group v-model="categoryFilter" multiple>
                        <v-list-item v-for="(category, index) in categories" :key="index" :value="category.id">
                        <v-list-item-content>
                            <v-list-item-title>{{ category.name }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-checkbox
                                style="pointer-events: none;"
                            v-model="categoryFilter"
                            :value="category.id"
                            hide-details
                            class="ml-2"
                            color="primary"
                            ></v-checkbox>
                        </v-list-item-action>
                        </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-menu>
                <div style="width:400px; flex-grow: 0;"><v-text-field outlined dense v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field></div>
            </v-toolbar>
            <v-card-text>

                <v-data-table
                    style="max-width: 100%; border: 1px solid #e0e0e0; border-radius: 4px;"
                    :headers="headers"
                    :items="data"
                    :loading="loading"
                    disable-pagination
                    :options.sync="pagination"
                    hide-default-footer
                    :custom-sort="sortData"
                    :search="search"
                >
                <template v-slot:body="{ items }">
                    <tbody v-if="initLoader">
                        <tr v-for="n in 12" :key="n">
                        <td class="px-0 table-loading" :colspan="headers.length">
                            <v-skeleton-loader type="list-item"></v-skeleton-loader>
                        </td>
                        </tr>
                    </tbody>
                    <tbody v-else-if="items.length > 0">
                        <tr v-for="item, index in items" :key="item.id" class="data-table__row">
                            <td class="pt-2"><img style="height: 40px;object-fit: contain;" class="" v-if="item.clientCompany.data.logo_path" :src="item.clientCompany.data.logo_path" alt="Logo"></td>

                            <td v-if="item.clientCompany.data.name">
                                <a @click="showCompanyDialog(item)">{{ item.clientCompany.data.name }}</a>
                            </td>
                            <td v-else>
                                <span>{{ (item.name + ' (not linked)') }}</span>
                            </td>
                            <td>
                                <template v-if="item.clientCompany.data.categories">
                                    <v-chip small outlined class="my-1 mx-1" v-for="(category, index) in item.clientCompany.data.categories.data" :key="index">
                                        {{ category.name }}
                                    </v-chip>
                                </template>
                            </td>
                            <td>{{ item.parsed_links_count }}</td>
                            <td><a @click="showLinks(item)">{{ item.links_count }}</a></td>
                            <td>{{ item.last_parsed_at }}</td>
                            <td style="flex-shrink: 0; width: 280px; min-width: 280px;">
                                <template v-if="verifiedEditing == index">
                                    <div style="display: flex; align-items: center;">
                                        <div style="flex-shrink: 100000;">
                                            <date-input v-model="verified_at" label="Verified Date"></date-input>
                                        </div>
                                        <v-icon style="height: 25px; width:25px;" @click="stopEditing()" class="ml-2 table-link">mdi-close</v-icon>
                                        <v-icon style="height: 25px; width:25px;" @click="saveVerified(item, index)" class="ml-2 table-link">mdi-check</v-icon>
                                    </div>
                                </template>
                                <template v-else-if="item.verified_at">
                                    <span v-if="verifiedAfterScraped(item)">{{ item.verified_at }}</span>
                                    <span v-else class="red--text lighten-2">{{ item.verified_at }}</span>
                                    <v-icon v-if="verifiedEditing == null" small @click="editVerified(item, index)" class="ml-2 table-link">mdi-pencil</v-icon>
                                </template>
                                <template v-else>
                                    <span class="grey--text lighten-2">Not verified</span>
                                    <v-icon v-if="verifiedEditing == null" small @click="editVerified(item, index)" class="ml-2 table-link">mdi-pencil</v-icon>
                                </template>
                                
                            </td>
                            <!-- autocomplete input for status -->
                            <td style="flex-shrink: 0; width: 400px; min-width: 400px">
                                <template v-if="statusEditing == index">
                                    <div style="display: flex; align-items: center;">
                                        <div style="flex-shrink: 100000;">
                                            <v-combobox 
                                                v-model="status"
                                                :items="['New', 'Minor', 'Major', 'Fixed']"
                                                hide-details
                                                single-line
                                                outlined
                                                multiple
                                                
                                                deletable-chips
                                                chips
                                                small-chips
                                                class="mt-0 py-2"
                                                :menu-props="{ closeOnContentClick: false }"
                                                :loading="loading"
                                                :loading-text="'Loading...'"
                                            ></v-combobox>
                                        </div>
                                        <v-icon style="height: 25px; width:25px;" @click="stopEditing()" class="ml-2 table-link">mdi-close</v-icon>
                                        <v-icon style="height: 25px; width:25px;" @click="saveStatus(item, index)" class="ml-2 table-link">mdi-check</v-icon>
                                    </div>
                                </template>
                                <!-- else show chips -->
                                <template v-else>
                                    <v-chip small outlined class="my-1 mr-2" v-for="(status, index) in parseStatus(item.comment)" :key="index">
                                        {{ status }}
                                    </v-chip>
                                    <template v-if="!item.comment">
                                        <!-- add status button -->
                                         <v-btn small @click="editStatus(item, index)" color="grey" text>Add Status
                                            <v-icon small class="ml-2">mdi-plus</v-icon>
                                         </v-btn>
                                    </template>
                                    <v-icon v-else-if="statusEditing == null" small @click="editStatus(item, index)" class="ml-2 table-link">mdi-pencil</v-icon>
                                </template>
                            </td>
                            <td class="text-center data-table__frozen-right">
                                <!-- view comments -->
                                <v-icon v-if="item.clientCompany.data.name" small @click="showCommentDialog(item)" class="table-link mx-1">mdi-comment-text-outline</v-icon>
                                <v-icon small @click="showDialog(item)" class="table-link mx-1">mdi-eye</v-icon>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td :colspan="headers.length" class="text-center">
                                No records found
                            </td>
                        </tr>
                    </tbody>
                </template>

                </v-data-table>
            </v-card-text>
        </v-col>
        <v-dialog
            v-model="commentDialog"
            scrollable
            width="600px"
        >
            <v-card v-if="selectedEntity">
                <v-toolbar :elevation="0" class="text-h6" dense><span>{{ selectedEntity.name }} Comments</span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="commentDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text class="pa-6">
                    <comments :item="selectedEntity" :entityId="selectedEntity.clientCompany.data.id" :entityType="'scraper'" :hideHeader="true" @updated="getData"></comments>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-row>

</template>

<script>
    import ViewRetailerDialog from '@/pages/core/ViewRetailerDialog.vue';
    import ViewLinks from '@/pages/core/ViewLinks.vue';
    import dateInput from '@/components/common/dateInput.vue';
    import EditCompanyDialog from "@/components/companies/editCompanyDialog";
    import Comments from "@/components/common/comments";

	export default {
		components: {
            ViewRetailerDialog,
            dateInput,
            ViewLinks,
            EditCompanyDialog,
            Comments,
		},
		data() {
			return {
				search: '',
                categoryFilter: [],
                categories: [],
				pagination: {},
				totalRecords: 0,
				loading: true,
                initLoader: true,
				sortBy: ['name'],
				sortDesc: [true],
				itemsPerPage: 100,
                showVerified: true,
                verifiedEditing: null,
                statusEditing: null,
                verified_at: null,
                status: null,
				page: 1,
				headers: [
                    {text: 'Logo', value: 'clientCompany.logo', sortable: false, class:'data-table__cell'},
                    {text: 'Retailer', value: 'name', sortable: true},
                    {text: 'Retailer Categories', value: 'clientCompany.categories', sortable: false, class:'data-table__cell'},
                    {text: 'Number of Stores', value: 'parsed_links_count', sortable: true, class:'data-table__cell'},
                    {text: 'Number of Links', value: 'links_count', sortable: true, class:'data-table__cell'},
                    {text: 'Last Scraped', value: 'last_parsed_at', sortable: true, class:'data-table__cell'},
                    {text: 'Verified On', value: 'verified_at', sortable: true, class:'data-table__cell'},
                    {text: 'Status', value: 'status', sortable: false, class:'data-table__cell'},
                    // {text: 'Comments', value: 'comment', sortable: false, class:'data-table__cell'},
                    {text: 'Actions', value: 'actions', sortable: false, width: '150px', align: 'center',class:'data-table__frozen-right'},
				],
				records: [],

                dialog: false,
                commentDialog: false,
                selectedEntity: null,
			}
		},
		mounted() {
            this.getData();
        },
		watch: {
		},
		computed: {
            data() {
                if (this.categoryFilter.length > 0) {
                    let filteredRecords = this.records.filter(item => {
                        return item.clientCompany && item.clientCompany.data && item.clientCompany.data.categories && item.clientCompany.data.categories.data.length > 0
                    });
                    return filteredRecords.filter(item => {
                        return item.clientCompany.data.categories.data.some(category => this.categoryFilter.includes(category.id));
                    });
                } else {
                    return this.records;
                }
            },
        },
		methods: {
            showRetailerDialog: function (item) {
                this.dialog = false
                if(item){
                    this.$refs.viewRetailerDialog.showDialog(item);
                }else if(this.selectedEntity){
                    this.$refs.viewRetailerDialog.showDialog(this.selectedEntity);
                }
            },

            showDialog(item) {
                this.selectedEntity = item
                this.dialog = true
            },

            showCommentDialog(item) {
                this.selectedEntity = item
                this.commentDialog = true
            },

            closeDialog() {
                this.selectedEntity = null
                this.dialog = false
            },

            showLinks: function (item) {
                this.$refs.viewLinks.showDialog(item);
            },


			getData() {
				this.loading = true
				this.$http.get('/scrapers/companies', {
					params: {
                        include: 'last_parsed_at, clientCompany, clientCompany.categories',
                        sort_by: this.pagination.sortBy[0],
                        desc: this.pagination.sortDesc[0] ? 1 : 0,
					}
				}).then(response => {
                    this.loading = false
                    this.initLoader = false
                    let data = response.data.data

                    if (this.showVerified) {
                        // filter out all retailers without a veri
                        data.data

                        data = data.filter(item => {
                            return !this.verifiedAfterScraped(item) || !item.verified_at
                        })
                    }

                    this.records = data
                    this.totalRecords = response.data.total

                    const categoryCountMap = {};
                    // filter out all retails without clientcompany
                    data = data.filter(item => {
                        return item.clientCompany && item.clientCompany.data && item.clientCompany.data.categories && item.clientCompany.data.categories.data.length > 0
                    })

                    data.forEach(item => {
                    (item.clientCompany.data.categories.data || []).forEach(category => {
                        if (categoryCountMap[category.id]) {
                        categoryCountMap[category.id].count++;
                        } else {
                        categoryCountMap[category.id] = {
                            id: category.id,
                            name: category.name,
                            count: 1
                        };
                        }
                    });
                    });

                    this.categories = Object.values(categoryCountMap).map(category => ({
                        id: category.id,
                        name: `${category.name} (${category.count})`
                    }));

                }).catch(error => {
                    this.loading = false
                    this.initLoader = false
                    // this.$store.dispatch('showSnackbar', {text: error.response.data.message, color: 'error'})
				})
			},

            // custom sort
            sortData(items, sortBy, sortDesc) {
                if (sortBy.length === 0) {
                    return items
                }

                return items.sort((a, b) => {
                    let sortA = a[sortBy[0]]
                    let sortB = b[sortBy[0]]
                    

                    if (typeof sortA === 'string') {
                        if((sortBy[0] == "last_parsed_at" || sortBy[0] == "verified_at")){                         
                            if (sortA) {
                                let dateA = sortA.split('/')
                                sortA = parseFloat(dateA[2] + dateA[1] + dateA[0])
                            } else {
                                if (sortDesc[0]) {
                                    sortA = 0
                                } else {
                                    sortA = 99999999
                                }
                            }
                            if (sortB) {
                                let dateB = sortB.split('/')
                                sortB = parseFloat(dateB[2] + dateB[1] + dateB[0])
                            } else {
                                if (sortDesc[0]) {
                                    sortB = 0
                                } else {
                                    sortB = 99999999
                                }
                            }
                            console.log(sortA, sortB)
                        }else{
                            return sortA.localeCompare(sortB) * (sortDesc[0] ? -1 : 1)
                        }

                    }

                    return (sortA - sortB) * (sortDesc[0] ? -1 : 1)
                })
                
            },

            parseStatus(status) {
                if (status) {
                    return status.split(',')
                } else {
                    return []
                }
            },

            editVerified(item, index) {
                this.verifiedEditing = index
                this.verified_at = item.verified_at
                this.statusEditing = null
                this.status = null
            },

            editStatus(item, index) {
                this.statusEditing = index
                this.status = this.parseStatus(item.comment)
                this.verifiedEditing = null
                this.verified_at = null
            },

            stopEditing() {
                this.verifiedEditing = null
                this.verified_at = null
                this.statusEditing = null
                this.status = null
            },

            saveVerified(item, index) {
                this.verifiedEditing = null
                // convert to MM/DD/YYYY from DD/MM/YYYY
                let verified_at = this.verified_at.split('/')
                
                verified_at = `${verified_at[1]}/${verified_at[0]}/${verified_at[2]}`

                this.$http.post(`/scrapers/${item.id}/verify`, {
                    verified_at: verified_at
                }).then(response => {
                    // this.$store.dispatch('showSnackbar', {text: 'Verified date updated successfully', color: 'success'})
                    this.getData()
                    this.stopEditing()
                }).catch(error => {
                    // this.$store.dispatch('showSnackbar', {text: error.response.data.message, color: 'error'})
                })
            },

            saveStatus(item, index) {
                console.log(item, index)
                // merge array into string separated by commas
                let status = this.status.join(',')
                this.statusEditing = null
                this.$http.put(`core-companies/${item.id}/update-comment`, {
                    comment: status
                }).then(response => {
                    // this.$store.dispatch('showSnackbar', {text: 'Status updated successfully', color: 'success'})
                    this.getData()
                    this.stopEditing()
                }).catch(error => {
                    // this.$store.dispatch('showSnackbar', {text: error.response.data.message, color: 'error'})
                })
            },

            showCompanyDialog(item) {
                this.$refs.editCompanyDialog.showDialog(item.clientCompany.data.id)
            },

            verifiedAfterScraped(item) {
                if (item.last_parsed_at && item.verified_at) {

                    let lastParsed = item.last_parsed_at.split('/')
                    let verified = item.verified_at.split('/')
                    
                    lastParsed = new Date(parseFloat(lastParsed[2]), parseFloat(lastParsed[1]) - 1, parseFloat(lastParsed[0]))
                    verified = new Date(parseFloat(verified[2]), parseFloat(verified[1]) - 1, parseFloat(verified[0]))

                    if (verified > lastParsed){
                        return true
                    }

                    return false
                }
                return true
            }
		}
	}
</script>

<style scoped>
    .table-link {
        text-decoration: none;
    }

    .table-smalltext{
        font-size: 12px;
        color: #9e9e9e;
    }
</style>
